import { Injectable } from '@angular/core';
import { HttpService } from 'projects/apex/src/app/services/http/http.service';
import { Observable } from 'rxjs';
import { createApiUrl } from '../../../utils/functions';
import { UserConsent, UserConsentConsent } from '../models/user-consent.model';

@Injectable()
export class UserConsentService extends HttpService<UserConsent, string> {
  route = 'user-consent';

  getUserConsentsForApartment(apartmentId: number): Observable<UserConsent[]> {
    const url = createApiUrl(`client/apartment/${apartmentId}/user-consent`);

    return this.http.get<UserConsent[]>(url, this.options);
  }

  setConsent(userConsentId: string): Observable<void> {
    const url = createApiUrl(`client/user-consent/${userConsentId}`);

    return this.http.post<void>(url, null, this.options);
  }

  deleteConsent(userConsentId: string): Observable<void> {
    const url = createApiUrl(`client/user-consent/${userConsentId}`);

    return this.http.delete<void>(url, this.options);
  }

  getAllUserConsentConsents(params: { ProjectId?: number; UserConsentId?: string }): Observable<UserConsentConsent[]> {
    const url = createApiUrl('user-consent-consent');

    return this.http.get<UserConsentConsent[]>(url, { ...this.options, params });
  }

  deleteUserConsentConsent(id: string): Observable<void> {
    const url = createApiUrl(`user-consent-consent/${id}`);

    return this.http.delete<void>(url, this.options);
  }
}
